import { useState, useEffect } from 'react'
import { getGroupsExpandAPI } from '../../services/division'

function UseGroupsExpand(orgId, searchs) {
  const [data, setData] = useState([])
  useEffect(() => {
    const param = {
      orgId,
      searchs
    }
    const getData = async () => {
      const result = await getGroupsExpandAPI(param)
      if (!result) return
      if (result.status) {
        const newData =
          result.result &&
          result.result.map((d) => {
            return {
              value: d?.ds_id,
              label: `${d?.division_en} (${d?.division})`,
              data: d?.division_en ?? ''
            }
          })

        setData(newData)
      }
    }
    if (orgId) {
      getData()
    }
  }, [orgId, searchs])

  return data
}

export default UseGroupsExpand
